import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { unstable_generateUtilityClasses as generateUtilityClasses } from "@mui/utils";
import { TreeItemRoot } from "@mui/x-tree-view-pro";
import { hasNotProp } from "@sinch/utils/object";

export const rateBuilderClasses = generateUtilityClasses("SinchRateBuilderTreeItemRoot", [
  "wrapper",
  "ifElseItem",
  "entryRate",
  "entryRateContent",
  "ifElseItemContent",
  "overview",
]);

export const RateBuilderTreeItemRoot = styled(TreeItemRoot, {
  shouldForwardProp: hasNotProp(["expanded"]),
})<BoxProps & { expanded?: boolean }>(({ theme }) => ({
  containerType: "inline-size",
  position: "relative",
  cursor: "unset",
  [`.${rateBuilderClasses.wrapper} &`]: {
    backgroundColor: "initial",
    borderRadius: `initial`,
  },
  [`.${rateBuilderClasses.wrapper}`]: {
    [`&:not(:first-of-type)`]: {
      marginTop: 0,
      //paddingTop: theme.spacing(2),
    },
  },
  "&:first-of-type": {
    marginTop: 0,
  },
  [`&.${rateBuilderClasses.overview}:last-of-type::before`]: {
    paddingBottom: "4px",
  },
  [`&.${rateBuilderClasses.entryRate}::before`]: {
    content: "' '",
    display: "block",
    position: "absolute",
    width: "1px",
    borderLeft: "var(--tree-lines-width, 2px) solid var(--lines-color)",
    height: "100%",
    left: `calc(var(--main-line-offset) * -1 - var(--tree-lines-width, 2px) / 2)`,
    top: 0,
  },
  [`&.${rateBuilderClasses.entryRate}.${rateBuilderClasses.overview}:last-of-type::before`]: {
    content: "none",
  },
  [`.${rateBuilderClasses.ifElseItem}:not(:last-child)`]: {
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));
